import { Box, Flex, Text, Title } from '@mantine/core';
import { FC } from 'react';
import { PodcastCardProps } from './types';
import Image from 'next/image';
import { PlayIcon } from '@heroicons/react/24/solid';
import { Badge } from '@atoms/Badge/index';
import Link from 'next/link';

export const PodcastCard: FC<PodcastCardProps> = ({ podcast }) => {
  const { category } = podcast ?? {};

  return (
    <Flex gap={0} direction="column">
      <Box
        pos="relative"
        sx={(theme) => ({
          paddingBottom: '75%',
          [`@media (min-width: ${theme.breakpoints.md})`]: {
            paddingBottom: '100%',
          },
        })}
      >
        <Link
          href={`/podcasts/${podcast?.slug}`}
          style={{ position: 'absolute', inset: 0, display: 'block' }}
          aria-label={podcast?.title}
        >
          <Image
            src={podcast?.header_image?.key ?? ''}
            alt={podcast?.title ?? ''}
            fill
            style={{ objectFit: 'cover' }}
            sizes="(max-width: 768px) 900px, (max-width: 1200px) 1366px, 700px"
          />
        </Link>
        <Box
          component={Link}
          href={`/podcasts/${podcast?.slug}`}
          pos="absolute"
          bottom={0}
          right={0}
          w={44}
          h={44}
          aria-label={`Play ${podcast?.title}`}
          sx={(theme) => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme.colors.primary[0],
            color: 'white',
          })}
        >
          <PlayIcon width={20} color="currentColor" />
        </Box>
      </Box>
      {category && (
        <Box w="fit-content" mt={8}>
          <Badge radius="none" color={category.color}>
            {category.name}
          </Badge>
        </Box>
      )}
      <Link
        href={`/podcasts/${podcast?.slug}`}
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        <Title
          order={4}
          variant="h4Dark"
          mt={4}
          mb={4}
          fw={700}
          style={{ textTransform: 'uppercase' }}
          lineClamp={2}
        >
          {podcast?.title}
        </Title>
      </Link>
      <Text variant="body1" lineClamp={3} component="p">
        {podcast?.description}
      </Text>
    </Flex>
  );
};
